export const DEFAULT = 'DEFAULT';
export const SAVED_WORKFLOW_FAILED = 'SAVED_WORKFLOW_FAILED';
export const SAVED_WORKFLOW_ENROLLMENT_FAILED = 'SAVED_WORKFLOW_ENROLLMENT_FAILED';
export const SAVED_ACTION_SET_SUCCESS = 'SAVED_ACTION_SET_SUCCESS';
export const CREATED_ENROLLMENT_SUCCESS = 'CREATED_ENROLLMENT_SUCCESS';
export const EXPORT_WORKFLOW_SUCCESS = 'EXPORT_WORKFLOW_SUCCESS';
export const DELETE_WORKFLOW_FAILED = 'DELETE_WORKFLOW_FAILED';
export const SAVED_GENERAL_SETTINGS_SUCCESS = 'SAVED_GENERAL_SETTINGS_SUCCESS';
export const SAVED_UNENROLLMENT_SETTINGS_SUCCESS = 'SAVED_UNENROLLMENT_SETTINGS_SUCCESS';
export const CLONE_WORKFLOW_FAILED = 'CLONE_WORKFLOW_FAILED';
export const CREATE_WORKFLOW_FAILED = 'CREATE_WORKFLOW_FAILED';
export const CREATE_FROM_TEMPLATE_FAILED = 'CREATE_FROM_TEMPLATE_FAILED';
export const DISABLED_WITH_NO_ACTIONS = 'DISABLED_WITH_NO_ACTIONS';
export const CLONE_FILTER_PROPERTY_TYPE_HAS_CHANGED = 'CLONE_FILTER_PROPERTY_TYPE_HAS_CHANGED';
export const CREATE_FILTER_PROPERTY_TYPE_HAS_CHANGED = 'CREATE_FILTER_PROPERTY_TYPE_HAS_CHANGED';
export const CLONE_WORKFLOW_NAME_LENGTH_INVALID = 'CLONE_WORKFLOW_NAME_LENGTH_INVALID';
export const CREATE_WORKFLOW_NAME_LENGTH_INVALID = 'CREATE_WORKFLOW_NAME_LENGTH_INVALID';
export const WORKFLOW_HAS_VALIDATION_ERRORS = 'WORKFLOW_HAS_VALIDATION_ERRORS';
export const CREATED_PLATFORM_ENROLLMENT_SUCCESS = 'CREATED_PLATFORM_ENROLLMENT_SUCCESS';
export const UPDATED_FOLDER_CONTENTS = 'UPDATED_FOLDER_CONTENTS';
export const UPDATED_FOLDER_CONTENTS_FAILED = 'UPDATED_FOLDER_CONTENTS_FAILED';
export const UPDATED_FOLDER_CONTENTS_FAILED_ROOT = 'UPDATED_FOLDER_CONTENTS_FAILED_ROOT';
export const UPDATED_FOLDER_CONTENTS_ROOT = 'UPDATED_FOLDER_CONTENTS_ROOT';
export const MOVE_FLOW_TO_FOLDER_AFTER_CREATE_FAILED = 'MOVE_FLOW_TO_FOLDER_AFTER_CREATE_FAILED';
export const CREATED_FOLDER = 'CREATED_FOLDER';
export const CREATE_FOLDER_FAILED = 'CREATE_FOLDER_FAILED';
export const DELETED_FOLDER = 'DELETED_FOLDER';
export const DELETED_FOLDER_FAILED = 'DELETED_FOLDER_FAILED';
export const DELETED_FOLDER_TEAM_CONTENT_FAILED = 'DELETED_FOLDER_TEAM_CONTENT_FAILED';
export const LIVE_UPDATE_TO_PLATFORM_HYBRID = 'LIVE_UPDATE_TO_PLATFORM_HYBRID';
export const UPDATED_EXECUTION_TIME_SETTINGS_META = 'UPDATED_SETTINGS_META';
export const UPDATED_EXECUTION_TIME_SETTINGS_META_FAILED = 'UPDATED_SETTINGS_META_FAILED';
export const OUTDATED_FLOW_VERSION = 'OUTDATED_FLOW_VERSION';
export const TEAM_ASSIGN_SUCCESS = 'TEAM_ASSIGN_SUCCESS';
export const TEAM_ASSIGN_FAIL = 'TEAM_ASSIGN_FAIL';
export const TEAM_ASSIGN_FAIL_PERMISSION_DENIED = 'TEAM_ASSIGN_FAIL_PERMISSION_DENIED';
export const DELETED_ACTION_FAILED = 'DELETED_ACTION_FAILED';
export const UPDATE_ACTION_FAILED = 'UPDATE_ACTION_FAILED';
export const UPDATE_REFERENCED_ACTION_FAILED = 'UPDATE_REFERENCED_ACTION_FAILED';
export const LOAD_RESOURCES_FAILED = 'LOAD_RESOURCES_FAILED';
export const WORKFLOW_NOTIFICATIONS_SETTINGS_SAVING_SUCCESS = 'WORKFLOW_NOTIFICATIONS_SETTINGS_SAVING_SUCCESS';
export const WORKFLOW_NOTIFICATIONS_SETTINGS_SAVING_FAIL = 'WORKFLOW_NOTIFICATIONS_SETTINGS_SAVING_FAIL';
export const WORKFLOW_METRICS_TOGGLE_SETTINGS_SAVING_FAIL = 'WORKFLOW_METRICS_TOGGLE_SETTINGS_SAVING_FAIL';
export const EVENT_ENROLLMENT_BETA_OPT_IN_FAILURE = 'EVENT_ENROLLMENT_BETA_OPT_IN_FAILURE';
export const EVENT_ENROLLMENT_BETA_OPT_OUT_FAILURE = 'EVENT_ENROLLMENT_BETA_OPT_OUT_FAILURE';
export const ACTION_SET_DELETE_SUCCESS = 'ACTION_SET_DELETE_SUCCESS';
export const ACTION_SET_DELETE_FAIL = 'ACTION_SET_DELETE_FAIL';
export const ACTION_LIMIT_REACHED = 'ACTION_LIMIT_REACHED';
export const COPY_NOT_SUPPORTED = 'COPY_NOT_SUPPORTED';
export const PASTE_FAILED = 'PASTE_FAILED';
export const PASTE_NO_ACTION_FAILURE = 'PASTE_NO_ACTION_FAILURE';
export const PASTE_OBJECT_MISMATCH_FAILURE = 'PASTE_OBJECT_MISMATCH_FAILURE';
export const PASTE_ACTION_MISMATCH_FAILURE = 'PASTE_ACTION_MISMATCH_FAILURE';
export const PASTE_SUCCESS = 'PASTE_SUCCESS';
export const UNDO_WORKFLOW_CHANGE_SUCCESS = 'UNDO_WORKFLOW_CHANGE_SUCCESS';
export const UNDO_WORKFLOW_CHANGE_FAIL_GENERIC = 'UNDO_WORKFLOW_CHANGE_FAIL_GENERIC';
export const REDO_WORKFLOW_CHANGE_SUCCESS = 'REDO_WORKFLOW_CHANGE_SUCCESS';
export const REDO_WORKFLOW_CHANGE_FAIL_GENERIC = 'REDO_WORKFLOW_CHANGE_FAIL_GENERIC';